import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import { createPinia } from 'pinia'
import './assets/tailwind.css'

// 🟡 Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

// adăugăm toate seturile în librărie
library.add(fas, fab, far)

// 🧱 creeăm aplicația
const app = createApp(App)
app.config.globalProperties.$backendUrl = process.env.VUE_APP_API_URL
// 🌍 Configurare globală Axios
// 🌍 Configurare globală Axios
axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}/api/`
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['X-Api-Key'] = `Api-Key ${process.env.VUE_APP_SCHOOL_API_KEY}`
axios.defaults.withCredentials = false // JWT, deci fără cookie

// 🔒 Dacă există token salvat, îl adăugăm la toate request-urile
const token = localStorage.getItem('access')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

// 2. Interceptor REQUEST: Adaugă token-ul dinamic la fiecare apel
axios.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('access')
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// 3. Interceptor RESPONSE: Prinde 401 și face refresh automat
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      
      const refreshToken = localStorage.getItem('refresh')

      if (refreshToken) {
        try {
          // Facem refresh folosind instanța curată de axios ca să nu intrăm în buclă cu interceptorul
          const response = await axios.post(`${process.env.VUE_APP_API_URL}/api/token/refresh/`, {
            refresh: refreshToken,
          })

          localStorage.setItem('access', response.data.access)
          if (response.data.refresh) {
            localStorage.setItem('refresh', response.data.refresh)
          }

          originalRequest.headers['Authorization'] = `Bearer ${response.data.access}`
          return axios(originalRequest)
          
        } catch (refreshError) {
          localStorage.removeItem('access')
          localStorage.removeItem('refresh')
          localStorage.removeItem('school_id')
          localStorage.removeItem('school_name')
          
          router.push('/admin/login')
          return Promise.reject(refreshError)
        }
      }
    }
    return Promise.reject(error)
  }
)
// adăugăm axios global
app.config.globalProperties.$axios = axios

// 🔗 înregistrăm FontAwesome global
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(createPinia())

// 🧭 montăm routerul și aplicația
app.use(router)
app.mount('#app')
